import { render, staticRenderFns } from "./howItWorks.vue?vue&type=template&id=237b4b5d&scoped=true"
import script from "./howItWorks.vue?vue&type=script&lang=js"
export * from "./howItWorks.vue?vue&type=script&lang=js"
import style0 from "./howItWorks.vue?vue&type=style&index=0&id=237b4b5d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237b4b5d",
  null
  
)

export default component.exports